"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./_internal/utils");
var toArray_1 = tslib_1.__importDefault(require("./toArray"));
function inner(obj, keys) {
    return Object.fromEntries(Object.entries(obj).filter(function (_a) {
        var _b = tslib_1.__read(_a, 1), k = _b[0];
        return keys.has(k);
    }));
}
function sync(iterable, obj) {
    var keys = new Set(iterable);
    return inner(obj, keys);
}
function async(iterable, obj) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var keys, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = Set.bind;
                    return [4 /*yield*/, (0, toArray_1.default)(iterable)];
                case 1:
                    keys = new (_a.apply(Set, [void 0, _b.sent()]))();
                    return [2 /*return*/, inner(obj, keys)];
            }
        });
    });
}
function pick(iterable, obj) {
    if (obj === undefined) {
        return function (obj) { return pick(iterable, obj); };
    }
    if ((0, utils_1.isIterable)(iterable)) {
        return sync(iterable, obj);
    }
    else if ((0, utils_1.isAsyncIterable)(iterable)) {
        return async(iterable, obj);
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
exports.default = pick;
//# sourceMappingURL=pick.js.map